/**

 * Bazi Report Generator - v5.0 (节气基准修正版)

 * ----------------------------------------------------------------

 * 修正内容（相对 v4.2）：

 *  - 年柱、月柱、大运：改用「出生时刻的北京时间」喂给 lunar.js，

 *    与 lunar.js 内部以北京时间表达的节气同基准，消除近节气排盘错误。

 *  - 日柱、时柱：仍用「真太阳时」，保留出生地时辰精度。

 *  - 十神（含藏干十神）：一律相对「真·日主（日柱天干）」重新计算，

 *    避免北京日柱与真太阳时日柱不同一天时算错十神。

 *  - 五行计数：改为基于组装好的混合四柱。

 *

 * ⚠️ 调用签名已变更：

 *    generateBaziReport(trueSolarTime, beijingTime, gender)

 *    必须同步更新 section 文件，否则会触发兼容性回退（见函数开头）。

 */



// ---------------------------------------------------------

// 1. 天干五行 / 阴阳

// ---------------------------------------------------------

function getGanElement(gan) {

  const map = {

    '甲': 'Wood', '乙': 'Wood', '丙': 'Fire', '丁': 'Fire',

    '戊': 'Earth', '己': 'Earth', '庚': 'Metal', '辛': 'Metal',

    '壬': 'Water', '癸': 'Water'

  };

  return map[gan] || '';

}



function getGanYinYang(gan) {

  const yang = ['甲', '丙', '戊', '庚', '壬'];

  return yang.includes(gan) ? 'Yang' : 'Yin';

}



// ---------------------------------------------------------

// 2. 十神计算（相对指定日主，独立于 lunar.js，避免基准污染）

//    五行相生顺序 Wood→Fire→Earth→Metal→Water→Wood

// ---------------------------------------------------------

function getShiShenGan(dayGan, targetGan) {

  if (!dayGan || !targetGan) return '';

  const order = ['Wood', 'Fire', 'Earth', 'Metal', 'Water'];

  const me = getGanElement(dayGan);

  const other = getGanElement(targetGan);

  if (!me || !other) return '';

  const mi = order.indexOf(me);

  const oi = order.indexOf(other);

  const same = getGanYinYang(dayGan) === getGanYinYang(targetGan);



  if (me === other)            return same ? '比肩' : '劫财';   // 同我

  if ((mi + 1) % 5 === oi)     return same ? '食神' : '伤官';   // 我生他

  if ((mi + 2) % 5 === oi)     return same ? '偏财' : '正财';   // 我克他

  if ((oi + 1) % 5 === mi)     return same ? '偏印' : '正印';   // 他生我

  if ((oi + 2) % 5 === mi)     return same ? '七杀' : '正官';   // 他克我

  return '';

}



// ---------------------------------------------------------

// 3. 安全调用

// ---------------------------------------------------------

function safeCall(obj, methodName, defaultValue) {

  try {

    if (obj && typeof obj[methodName] === 'function') {

      return obj[methodName]();

    }

  } catch (e) {

    console.warn(`Error calling ${methodName}:`, e);

  }

  return defaultValue;

}



// ---------------------------------------------------------

// 4. 五行计数（基于组装好的混合四柱，含藏干权重 1.0 / 0.5 / 0.3）

// ---------------------------------------------------------

function getFiveElementsCount(pillars) {

  const wuXingMap = {

    '甲': '木', '乙': '木', '丙': '火', '丁': '火', '戊': '土',

    '己': '土', '庚': '金', '辛': '金', '壬': '水', '癸': '水'

  };

  const elementKeys = { '木': 'wood', '火': 'fire', '土': 'earth', '金': 'metal', '水': 'water' };

  const counts = { wood: 0, fire: 0, earth: 0, metal: 0, water: 0 };

  const cangGanWeights = [1.0, 0.5, 0.3];



  const order = [

    ['年', pillars.year], ['月', pillars.month],

    ['日', pillars.day],  ['时', pillars.hour]

  ];



  console.log('【五行计算 v5.0 - 基于混合四柱（年/月=北京时间, 日/时=真太阳时）】');

  order.forEach(([name, p]) => {

    if (!p) return;

    const ge = wuXingMap[p.gan];

    if (ge && elementKeys[ge]) {

      counts[elementKeys[ge]] += 1.0;

      console.log(`  ${name}干 ${p.gan} → ${ge} (+1.0)`);

    }

    const hide = Array.isArray(p.hideGan) ? p.hideGan : [];

    hide.forEach((g, i) => {

      const e = wuXingMap[g];

      const w = cangGanWeights[i] || 0.3;

      if (e && elementKeys[e]) {

        counts[elementKeys[e]] += w;

        console.log(`  ${name}支藏干 ${g} → ${e} (+${w})`);

      }

    });

  });

  console.log('  五行合计:', JSON.stringify({

    wood: +counts.wood.toFixed(2), fire: +counts.fire.toFixed(2),

    earth: +counts.earth.toFixed(2), metal: +counts.metal.toFixed(2),

    water: +counts.water.toFixed(2)

  }));

  return counts;

}



// ---------------------------------------------------------

// 5. 组装单柱（shiShenGan / shiShenZhi 一律相对 trueDayGan 计算）

//    prefix: 'Year' | 'Month' | 'Day' | 'Time'

// ---------------------------------------------------------

function buildPillar(ec, prefix, trueDayGan, isDay) {

  const gan = safeCall(ec, 'get' + prefix + 'Gan', '');

  const hideGanRaw = safeCall(ec, 'get' + prefix + 'HideGan', []);

  const hideGan = Array.isArray(hideGanRaw) ? hideGanRaw : [];

  return {

    ganZhi:     safeCall(ec, 'get' + prefix, ''),

    gan:        gan,

    zhi:        safeCall(ec, 'get' + prefix + 'Zhi', ''),

    wuXing:     safeCall(ec, 'get' + prefix + 'WuXing', ''),

    naYin:      safeCall(ec, 'get' + prefix + 'NaYin', ''),

    shiShenGan: isDay ? '日主' : getShiShenGan(trueDayGan, gan),

    shiShenZhi: hideGan.map(g => getShiShenGan(trueDayGan, g)),

    diShi:      safeCall(ec, 'get' + prefix + 'DiShi', ''),   // 次要信息，下游未使用

    xunKong:    safeCall(ec, 'get' + prefix + 'XunKong', ''),

    hideGan:    hideGan

  };

}



// ---------------------------------------------------------

// 6. 主函数

//    tst    : 真太阳时 Date（真太阳时编码在 UTC 字段）

//    bjt    : 出生时刻的北京时间 Date（北京时间编码在 UTC 字段）

//    gender : 'male' | 'female'

// ---------------------------------------------------------

function generateBaziReport(tst, bjt, gender) {



  // ---- 兼容性保护：旧版只传两个参数会进入此分支 ----

  if (!(bjt instanceof Date)) {

    console.error(

      '[generateBaziReport] 缺少北京时间参数！请同步更新 section 文件，' +

      '调用应为 generateBaziReport(trueSolarTime, beijingTime, gender)。' +

      '当前回退为旧行为：年/月柱仍按真太阳时，节气基准未修正。'

    );

    gender = bjt;   // 旧签名第二个参数其实是 gender

    bjt = tst;      // 回退

  }



  console.log('┌─ generateBaziReport v5.0 (节气基准修正版) ─┐');

  console.log('真太阳时 TST (用于日柱/时柱):', tst.toISOString());

  console.log('北京时间 BJ  (用于年柱/月柱/大运):', bjt.toISOString());



  // ---- 真太阳时 Solar：日柱、时柱 ----

  const solarTst = Solar.fromYmdHms(

    tst.getUTCFullYear(), tst.getUTCMonth() + 1, tst.getUTCDate(),

    tst.getUTCHours(), tst.getUTCMinutes(), tst.getUTCSeconds()

  );

  const lunarTst = solarTst.getLunar();

  const eightCharTst = lunarTst.getEightChar();



  // ---- 北京时间 Solar：年柱、月柱、大运（与 lunar.js 的北京时间节气同基准）----

  const solarBj = Solar.fromYmdHms(

    bjt.getUTCFullYear(), bjt.getUTCMonth() + 1, bjt.getUTCDate(),

    bjt.getUTCHours(), bjt.getUTCMinutes(), bjt.getUTCSeconds()

  );

  const lunarBj = solarBj.getLunar();

  const eightCharBj = lunarBj.getEightChar();



  // 真·日主 = 日柱天干（来自真太阳时）

  const trueDayGan = eightCharTst.getDayGan();



  // ---- 调试：两套基准的年/月柱是否不同（不同 => 修正实际生效）----

  const yearDiff = eightCharTst.getYear() !== eightCharBj.getYear();

  const monthDiff = eightCharTst.getMonth() !== eightCharBj.getMonth();

  console.log('年柱  TST:', eightCharTst.getYear(), '| BJ:', eightCharBj.getYear(),

              yearDiff ? '  ← 不同，节气基准修正生效' : '  (相同，离节气较远)');

  console.log('月柱  TST:', eightCharTst.getMonth(), '| BJ:', eightCharBj.getMonth(),

              monthDiff ? '  ← 不同，节气基准修正生效' : '  (相同，离节气较远)');

  console.log('日柱:', eightCharTst.getDay(), '| 时柱:', eightCharTst.getTime(), '(均来自真太阳时)');



  // ---- 大运（起运 = 出生到节气的距离 → 必须北京时间基准）----

  const genderValue = (gender === 'male') ? 1 : 0;

  const yun = eightCharBj.getYun(genderValue);

  const daYunCycles = yun.getDaYun(10);

  const currentYear = 2027;



  let currentDayunIndex = -1;

  const luckCycles = daYunCycles.map((cycle, index) => {

    const startYear = safeCall(cycle, 'getStartYear', 0);

    const endYear = safeCall(cycle, 'getEndYear', 0);

    if (currentYear >= startYear && currentYear <= endYear) currentDayunIndex = index;



    let liuNianData = [];

    try {

      const liuNianCycles = cycle.getLiuNian();

      const xiaoYunCycles = cycle.getXiaoYun();

      liuNianData = liuNianCycles.map((ln, idx) => ({

        year: safeCall(ln, 'getYear', 0),

        age: safeCall(ln, 'getAge', 0),

        ganZhi: safeCall(ln, 'getGanZhi', ''),

        xiaoYunGanZhi: xiaoYunCycles[idx] ? safeCall(xiaoYunCycles[idx], 'getGanZhi', '') : ''

      }));

    } catch (e) {

      console.warn('Error getting liu nian:', e);

    }



    const ganZhi = safeCall(cycle, 'getGanZhi', '');

    return {

      ganZhi: ganZhi,

      gan: ganZhi[0] || '',

      zhi: ganZhi[1] || '',

      startAge: safeCall(cycle, 'getStartAge', 0),

      endAge: safeCall(cycle, 'getEndAge', 0),

      startYear: startYear,

      endYear: endYear,

      liuNian: liuNianData

    };

  });



  // ---- 起运信息 ----

  let yunInfo = {

    startAge: 0, startYear: 0, startMonth: 1, startDay: 1,

    isForward: true, description: '顺行 Forward'

  };

  try {

    if (luckCycles.length > 0) {

      yunInfo.startAge = luckCycles[0].startAge;

      yunInfo.startYear = luckCycles[0].startYear;

    }

    if (typeof yun.isForward === 'function') yunInfo.isForward = yun.isForward();

    else if (typeof yun.isShun === 'function') yunInfo.isForward = yun.isShun();

    yunInfo.description = yunInfo.isForward ? '顺行 Forward' : '逆行 Backward';

  } catch (e) {

    console.warn('Error getting yun info:', e);

  }



  // ---- 当前大运 ----

  let currentDayun = null;

  if (currentDayunIndex >= 0 && currentDayunIndex < luckCycles.length) {

    currentDayun = { ...luckCycles[currentDayunIndex], index: currentDayunIndex, isCurrent: true };

  } else if (luckCycles.length > 0) {

    currentDayun = { ...luckCycles[0], index: 0, isCurrent: false, notStarted: true };

  }



  // ---- 当前流年 ----

  let currentLiuNian = null;

  if (currentDayun && currentDayun.liuNian) {

    for (let ln of currentDayun.liuNian) {

      if (ln.year === currentYear) { currentLiuNian = ln; break; }

    }

  }

  if (!currentLiuNian) {

    try {

      const cs = Solar.fromYmd(currentYear, 6, 1);

      const yearGanZhi = cs.getLunar().getYearInGanZhi();

      currentLiuNian = { year: currentYear, ganZhi: yearGanZhi, gan: yearGanZhi[0] || '', zhi: yearGanZhi[1] || '' };

    } catch (e) {

      currentLiuNian = { year: currentYear, ganZhi: '', gan: '', zhi: '' };

    }

  }



  // ---- 日主信息（来自日柱 = 真太阳时）----

  const dayMaster = trueDayGan;

  const dayMasterElement = getGanElement(dayMaster);

  const dayMasterYinYang = getGanYinYang(dayMaster);



  // ---- 四柱组装：年/月 ← 北京时间；日/时 ← 真太阳时 ----

  const pillars = {

    year:  buildPillar(eightCharBj,  'Year',  trueDayGan, false),

    month: buildPillar(eightCharBj,  'Month', trueDayGan, false),

    day:   buildPillar(eightCharTst, 'Day',   trueDayGan, true),

    hour:  buildPillar(eightCharTst, 'Time',  trueDayGan, false)

  };



  // ---- 特殊宫位 / 黄历 / 生肖（次要信息）----

  const specialPalaces = {

    taiYuan:  safeCall(eightCharBj, 'getTaiYuan', ''),   // 胎元由月柱推 → 北京基准

    mingGong: safeCall(eightCharBj, 'getMingGong', ''),

    shenGong: safeCall(eightCharBj, 'getShenGong', '')

  };

  const almanac = {

    yi:       safeCall(lunarTst, 'getDayYi', []).join(', '),

    ji:       safeCall(lunarTst, 'getDayJi', []).join(', '),

    chong:    safeCall(lunarTst, 'getDayChongShengXiao', ''),

    sha:      safeCall(lunarTst, 'getDaySha', ''),

    jiShen:   safeCall(lunarTst, 'getDayJiShen', []).join(' '),

    xiongSha: safeCall(lunarTst, 'getDayXiongSha', []).join(' ')

  };

  const zodiac = {

    year:  safeCall(lunarBj, 'getYearShengXiao', ''),    // 年生肖以立春为界 → 北京基准

    month: safeCall(lunarBj, 'getMonthShengXiao', ''),

    day:   safeCall(lunarTst, 'getDayShengXiao', ''),

    hour:  safeCall(lunarTst, 'getTimeShengXiao', '')

  };



  // ---- 五行（基于组装好的混合四柱）----

  const fiveElements = getFiveElementsCount(pillars);



  return {

    dayMaster: dayMaster,

    dayMasterElement: dayMasterElement,

    dayMasterYinYang: dayMasterYinYang,

    dayMasterFull: `${dayMaster} (${dayMasterYinYang} ${dayMasterElement})`,



    pillars: pillars,



    yunInfo: yunInfo,

    currentDayun: currentDayun,

    currentLiuNian: currentLiuNian,

    luckCycles: luckCycles,



    specialPalaces: specialPalaces,

    fiveElements: fiveElements,

    almanac: almanac,

    zodiac: zodiac,



    solarDate: solarTst.toYmdHms(),

    lunarDate: lunarTst.toString(),



    meta: {

      generatedAt: new Date().toISOString(),

      version: '5.0-jieqi-basis-fix',

      gender: gender,

      tstISO: tst.toISOString(),

      bjISO: bjt.toISOString()

    }

  };

}